import React from 'react';
import { Container, Title, SubTitle, TitleContainer } from './styles';

export const NewBanner = ({ company, banner }) => {
  const bannerImage = banner?.banner?.url || company?.banner_url;
  return (
    <Container primaryColor={company?.base_hexcolor} actived={banner?.active} hasImage={bannerImage ? true : false}>
      <div>
        {bannerImage && (
          <img
            src={bannerImage}
            alt=""
          />
        )}
      </div>
      {banner?.has_title ? (
        <TitleContainer>
          {' '}
          <Title>{banner?.title || company?.subtitle}</Title>
          {banner?.sub_title && banner?.sub_title !== 'null' && <SubTitle>{ banner?.sub_title }</SubTitle>}
        </TitleContainer>
      ) : ''}
    </Container>
  );
};
